import { permissionSetsSlice } from './slice';
export const { putAll } = permissionSetsSlice.actions;
